import type { SectionProps } from '@/components/sitemap/Section';
import { sharedConfig } from '@/pageConfig/shared';
import sections from '@/static/sitemap.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  section: SectionProps[];
}

export const config: Config = {
  layout: { ...sharedConfig['en-GB'].layout },
  seo: {
    ...sharedConfig['en-GB'].seo,
    title: 'HTML Sitemap | Lemonade Insurance UK',
    metaTitle: 'HTML Sitemap | Lemonade Insurance UK',
    description:
      'Browse Lemonade UK’s sitemap for a clear overview of all pages, making it easy to navigate and find Home insurance resources and information.',
  },
  section: sections['en-GB'],
};
